/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'notification': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M383.994 896.002H639.99a127.998 127.998 0 01-255.996 0zM63.999 832.003a63.999 63.999 0 010-127.998h32a278.651 278.651 0 0095.998-191.997V320.011A316.923 316.923 0 01511.992.017 316.859 316.859 0 01831.986 320.01v191.997a278.46 278.46 0 0095.999 191.997h32a63.999 63.999 0 010 127.998z"/>'
  }
})
